const messages = {
  dashboard: {
    title: "Aussendienst Dashboard",
    description:
      "Herzlichen willkommen auf Ihrem Dashboard. Hier können Sie aktuelle Kennzahlen und teilnehmende Betriebe aus Ihrer Kundschaft einsehen.",
    overview: {
      title: "Übersicht teilnehmende Kunden",
      description:
        'Betriebe, die sich bei BRIDGESTONE <span class="text-danger">PLUS</span> mit angemeldet haben und die wir über die Kundennummer Ihnen zuordnen können.',
      month: "Neu diesen Monat",
      year: "Neu dieses Jahr",
      all: "Gesamt",
    },
    credits: {
      title: "Punktegutschriften",
      description:
        "Prämienpunkte, die teilnehmenden Betrieben aufgrund der übermittelten Absatzzahlen zugewiesen haben.",
      month: "Aktueller Monat",
      year: "Aktuelles Jahr",
      prev_year: "Letztes Jahr",
      allDealers: "Alle Händlerpunkte",
      allPoints: "Alle Punkte",
      prev_month: "Letzter Monat",
      tenant: {
        de_ch: {
          title: "Punktegutschriften",
          description:
            "Prämienpunkte, die teilnehmenden Betrieben aufgrund der übermittelten Absatzzahlen zugewiesen haben.",
          prev_month: "Letzter Monat",
          month: "Aktueller Monat",
          prev_year: "Letztes Jahr",
          allPoints: "Alle Punkte",
          allDealers: "Alle Händlerpunkte",
        },
        nl: {
          title: "Overzicht Marketingpunten",
          description:
            "Marketingpunkte werden teilnehmenden Betrieben auf Basis der eingereichten Verkaufszahlen gutgeschrieben.",
          prev_month: "Letzter Monat",
          month: "Aktueller Monat",
          year: "Im aktuellen Jahr gesamt gesammelt",
          prev_year: "Im letzten Jahr gesamt gesammelt",
        },
      },
    },
    details: {
      title: "Teilnehmende Kunden im Detail",
      description:
        'Nachfolgend sind die Betriebe aufgeführt, die sich mit einer Bridgestone Kundennummer auf BRIDGESTONE <span class="text-danger">PLUS</span> registriert haben und die Ihnen als Zuständigem/r zugewiesen sind. Nutzen Sie einfach Sortierfunktionen für eine andere Reifenfolge oder die Suchmaske.<br/><br/> <b>Hinweis:</b> Wenn Sie auf den Punktestand klicken, gelangen Sie zum detaillierten Kontoauszug.',
    },
    lastImport:
      'Letzter Import von Absatzzahlen: <br/> <span class="text-danger">{date}</span>',
    kickback: {
      description:
        "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
    },
    tyres: {
      title: "Reifen",
      description: "Bon Programmteilnehmern gekaufte Reifen",
    },
    short:
      "Welcome to your dashboard. Here you can view current figures and participating companies from your customer base.",
    headers: {
      city: "ORT",
      company: "Firma",
      current_points: "Punktestand",
      customer_number: "Kdnr.",
      details: "Details",
      last_login: "Letzer Log-in",
      name: "Name",
      postal_code: "PLZ",
      street: "Strasse",
      email: "Email",
      created_at: "Registriert am",
      calculation_date: "Berechnungsdatum",
    },
    reload: "Neu laden",
    exports: {
      title: "Exportierte Excel-Dateien",
      downloadExcel: "Excel herunterladen",
      running: "Läuft",
      head: {
        name: "Name",
        status: "Status",
      },
    },
  },
};

export default {
  messages,
};
